module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-card-layout"
  }, [(_vm.$slots.formPlace) ? _c('div', {
    staticClass: "app-card-layout__form"
  }, [_vm._t("formPlace")], 2) : _vm._e(), _c('div', {
    staticClass: "app-card-layout__main",
    class: [("app-card-layout__main_" + _vm.sidebarPosition), {
      'app-card-layout__main_no-slider': _vm.isNoSlider
    }]
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13776214","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/layouts/cardlayouts/CardLayout/AppCardLayout.vue
// module id = 6479262db95b010f9c67
// module chunks = 89